export enum LevelOfDetail {
  total = 'total',
  daily = 'daily',
  weekly = 'weekly',
  monthly = 'monthly',
}